// @flow

import React, { Component } from 'react';
import androidAppStoreCS from 'app/common/images/app_store_buttons/current/android/CS@2x.png';
import androidAppStoreDA from 'app/common/images/app_store_buttons/current/android/DA@2x.png';
import androidAppStoreDE from 'app/common/images/app_store_buttons/current/android/DE@2x.png';
import androidAppStoreEL from 'app/common/images/app_store_buttons/current/android/EL@2x.png';
import androidAppStoreEN from 'app/common/images/app_store_buttons/current/android/EN@2x.png';
import androidAppStoreES from 'app/common/images/app_store_buttons/current/android/ES@2x.png';
import androidAppStoreFI from 'app/common/images/app_store_buttons/current/android/FI@2x.png';
import androidAppStoreFR from 'app/common/images/app_store_buttons/current/android/FR@2x.png';
import androidAppStoreHU from 'app/common/images/app_store_buttons/current/android/HU@2x.png';
import androidAppStoreID from 'app/common/images/app_store_buttons/current/android/ID@2x.png';
import androidAppStoreIT from 'app/common/images/app_store_buttons/current/android/IT@2x.png';
import androidAppStoreJA from 'app/common/images/app_store_buttons/current/android/JA@2x.png';
import androidAppStoreKO from 'app/common/images/app_store_buttons/current/android/KO@2x.png';
import androidAppStoreML from 'app/common/images/app_store_buttons/current/android/ML@2x.png';
import androidAppStoreNL from 'app/common/images/app_store_buttons/current/android/NL@2x.png';
import androidAppStoreNN from 'app/common/images/app_store_buttons/current/android/NN@2x.png';
import androidAppStorePL from 'app/common/images/app_store_buttons/current/android/PL@2x.png';
import androidAppStorePT from 'app/common/images/app_store_buttons/current/android/PT@2x.png';
import androidAppStoreRO from 'app/common/images/app_store_buttons/current/android/RO@2x.png';
import androidAppStoreRU from 'app/common/images/app_store_buttons/current/android/RU@2x.png';
import androidAppStoreSK from 'app/common/images/app_store_buttons/current/android/SK@2x.png';
import androidAppStoreSV from 'app/common/images/app_store_buttons/current/android/SV@2x.png';
import androidAppStoreTH from 'app/common/images/app_store_buttons/current/android/TH@2x.png';
import androidAppStoreTL from 'app/common/images/app_store_buttons/current/android/TL@2x.png';
import androidAppStoreTR from 'app/common/images/app_store_buttons/current/android/TR@2x.png';
import androidAppStoreUK from 'app/common/images/app_store_buttons/current/android/UK@2x.png';
import androidAppStoreVI from 'app/common/images/app_store_buttons/current/android/VI@2x.png';
import androidAppStoreZHCN from 'app/common/images/app_store_buttons/current/android/zhCN@2x.png';
import androidAppStoreZHTW from 'app/common/images/app_store_buttons/current/android/zhTW@2x.png';
import cx from 'classnames';
import i18n from 'app/common/lib/i18n';
import iosAppStoreCS from 'app/common/images/app_store_buttons/current/ios/CS@2x.png';
import iosAppStoreDA from 'app/common/images/app_store_buttons/current/ios/DA@2x.png';
import iosAppStoreDE from 'app/common/images/app_store_buttons/current/ios/DE@2x.png';
import iosAppStoreEL from 'app/common/images/app_store_buttons/current/ios/EL@2x.png';
import iosAppStoreEN from 'app/common/images/app_store_buttons/current/ios/EN@2x.png';
import iosAppStoreES from 'app/common/images/app_store_buttons/current/ios/ES@2x.png';
import iosAppStoreFI from 'app/common/images/app_store_buttons/current/ios/FI@2x.png';
import iosAppStoreFR from 'app/common/images/app_store_buttons/current/ios/FR@2x.png';
import iosAppStoreHU from 'app/common/images/app_store_buttons/current/ios/HU@2x.png';
import iosAppStoreID from 'app/common/images/app_store_buttons/current/ios/ID@2x.png';
import iosAppStoreIT from 'app/common/images/app_store_buttons/current/ios/IT@2x.png';
import iosAppStoreJA from 'app/common/images/app_store_buttons/current/ios/JA@2x.png';
import iosAppStoreKO from 'app/common/images/app_store_buttons/current/ios/KO@2x.png';
import iosAppStoreML from 'app/common/images/app_store_buttons/current/ios/ML@2x.png';
import iosAppStoreNL from 'app/common/images/app_store_buttons/current/ios/NL@2x.png';
import iosAppStoreNN from 'app/common/images/app_store_buttons/current/ios/NN@2x.png';
import iosAppStorePL from 'app/common/images/app_store_buttons/current/ios/PL@2x.png';
import iosAppStorePT from 'app/common/images/app_store_buttons/current/ios/PT@2x.png';
import iosAppStoreRO from 'app/common/images/app_store_buttons/current/ios/RO@2x.png';
import iosAppStoreRU from 'app/common/images/app_store_buttons/current/ios/RU@2x.png';
import iosAppStoreSK from 'app/common/images/app_store_buttons/current/ios/SK@2x.png';
import iosAppStoreSV from 'app/common/images/app_store_buttons/current/ios/SV@2x.png';
import iosAppStoreTH from 'app/common/images/app_store_buttons/current/ios/TH@2x.png';
import iosAppStoreTL from 'app/common/images/app_store_buttons/current/ios/TL@2x.png';
import iosAppStoreTR from 'app/common/images/app_store_buttons/current/ios/TR@2x.png';
import iosAppStoreUK from 'app/common/images/app_store_buttons/current/ios/UK@2x.png';
import iosAppStoreVI from 'app/common/images/app_store_buttons/current/ios/VI@2x.png';
import iosAppStoreZHCN from 'app/common/images/app_store_buttons/current/ios/zhCN@2x.png';
import iosAppStoreZHTW from 'app/common/images/app_store_buttons/current/ios/zhTW@2x.png';
import PropTypes from 'prop-types';
import type { AuthViewer } from 'app/packages/pinterest-flow-types/viewer';
import withViewer from 'app/common/lib/react/withViewer';
import { Box, IconButton } from 'gestalt';

type HeroProps = {
  currentEmail?: string,
  experienceId: number,
  handleComplete: () => void,
  handleDismiss: () => void,
  headerText?: string,
  subText?: string,
  titleText?: string,
  viewer: AuthViewer,
};

export const languageToAppDownload = {
  android: {
    CS: androidAppStoreCS,
    DA: androidAppStoreDA,
    DE: androidAppStoreDE,
    EL: androidAppStoreEL,
    EN: androidAppStoreEN,
    ES: androidAppStoreES,
    FI: androidAppStoreFI,
    FR: androidAppStoreFR,
    HU: androidAppStoreHU,
    ID: androidAppStoreID,
    IT: androidAppStoreIT,
    JA: androidAppStoreJA,
    KO: androidAppStoreKO,
    ML: androidAppStoreML,
    NL: androidAppStoreNL,
    NN: androidAppStoreNN,
    PL: androidAppStorePL,
    PT: androidAppStorePT,
    RO: androidAppStoreRO,
    RU: androidAppStoreRU,
    SK: androidAppStoreSK,
    SV: androidAppStoreSV,
    TH: androidAppStoreTH,
    TL: androidAppStoreTL,
    TR: androidAppStoreTR,
    UK: androidAppStoreUK,
    VI: androidAppStoreVI,
    'ZH-CN': androidAppStoreZHCN,
    'ZH-TW': androidAppStoreZHTW,
  },
  ios: {
    CS: iosAppStoreCS,
    DA: iosAppStoreDA,
    DE: iosAppStoreDE,
    EL: iosAppStoreEL,
    EN: iosAppStoreEN,
    ES: iosAppStoreES,
    FI: iosAppStoreFI,
    FR: iosAppStoreFR,
    HU: iosAppStoreHU,
    ID: iosAppStoreID,
    IT: iosAppStoreIT,
    JA: iosAppStoreJA,
    KO: iosAppStoreKO,
    ML: iosAppStoreML,
    NL: iosAppStoreNL,
    NN: iosAppStoreNN,
    PL: iosAppStorePL,
    PT: iosAppStorePT,
    RO: iosAppStoreRO,
    RU: iosAppStoreRU,
    SK: iosAppStoreSK,
    SV: iosAppStoreSV,
    TH: iosAppStoreTH,
    TL: iosAppStoreTL,
    TR: iosAppStoreTR,
    UK: iosAppStoreUK,
    VI: iosAppStoreVI,
    'ZH-CN': iosAppStoreZHCN,
    'ZH-TW': iosAppStoreZHTW,
  },
};

export class AppUpsellHero extends Component<HeroProps> {
  static contextTypes = {
    language: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
  };

  static defaultProps = {
    handleComplete: () => {},
    handleDismiss: () => {},
  };

  getHeaderText() {
    const { headerText } = this.props;

    if (headerText) {
      return headerText;
    } else {
      return i18n._('Want the best Pinterest? Get the free app!');
    }
  }

  render() {
    const { handleDismiss } = this.props;

    const className = cx('Module', 'HeroBasic', 'upsellHero');

    const { language, locale } = this.context;
    const lang = (language.startsWith('zh') ? locale : language).toUpperCase();

    let iosUrl;
    let androidUrl;

    if (lang in languageToAppDownload.android) {
      androidUrl = languageToAppDownload.android[lang];
      iosUrl = languageToAppDownload.ios[lang];
    } else {
      androidUrl = languageToAppDownload.android.EN;
      iosUrl = languageToAppDownload.ios.EN;
    }

    const androidAlt = i18n._('Install the Pinterest app on Android');
    const iosAlt = i18n._('Install the Pinterest app on iOS');

    return (
      <div style={{ position: 'sticky', top: '65px', zIndex: 2 }}>
        <div className={className}>
          <Box color="darkGray">
            <div className="hero">
              <div className="heroContainer">
                <Box marginTop={4} marginRight={3} position="absolute" right>
                  <IconButton
                    accessibilityLabel="Close"
                    iconColor="white"
                    icon="cancel"
                    onClick={handleDismiss}
                    size="sm"
                  />
                </Box>
                <div className="upsellTextButtons">
                  <div className="bodyText">
                    {this.getHeaderText()}
                    <br />
                  </div>
                  <div className="appButtons">
                    <a
                      className="appInstallButton"
                      href="https://bnc.lt/unauth-android-upsell-desktop-web"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <img className="androidButton" src={androidUrl} alt={androidAlt} />
                    </a>
                    <a
                      className="appInstallButton"
                      href="https://bnc.lt/unauth-ios-upsell-desktop-web"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <img className="iosButton" src={iosUrl} alt={iosAlt} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </div>
    );
  }
}

export default withViewer(AppUpsellHero);
